import React, {useEffect,useState} from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import theme from 'theme';

import 'i18n/config';
import { useTranslation } from 'react-i18next';

function NotFound() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 500);
  }, []);

  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: theme.palette.primary.main,
          opacity: show ? 1 : 0,
          transition: 'opacity 0.5s',
        }}
      >
        <Typography variant="h1" style={{ fontFamily: 'Saira Semi Condensed', fontSize:200, color: theme.palette.primary.main }}>
          404
        </Typography>
        <Typography variant="h3" style={{ fontFamily: 'Saira Semi Condensed' }}>
          {t('Page not found')}
        </Typography>
      </Box>
    </AppLayout>
  );
}

export default NotFound;
